import { apiHolder as api, apis, inWindow, DEFAULT_LANG, conf as config, getIn18Text } from 'api';
import juice from 'juice';
import debounce from 'lodash/debounce';
import throttle from 'lodash/throttle';
import { handleCopyImg } from '@web-mail/components/ReadMail/util';
import { fontFaceStyles } from '@web-common/components/UI/LxEditor/fontFaceStyle';
const systemApi = api.api.getSystemApi();
const mailConfApi = api.api.requireLogicalApi(apis.mailConfApiImpl);
const inElectron = systemApi.isElectron();
const iframeCsp = config('iframeCsp');
export const getMailEditorContentStyle = () => {
    try {
        const imgBottomStyle = mailConfApi.canUseImgBottomAlign() ? ' img {vertical-align: bottom;}' : '';
        return `body {margin: 0; font-size: 14px; line-height: 1.5;}${imgBottomStyle} ${fontFaceStyles}`;
    }
    catch (error) {
        return `body {margin: 0; font-size: 14px; line-height: 1.5;} ${fontFaceStyles}`;
    }
};
const tinyStyle = getMailEditorContentStyle();
const defaultStyle = `
    body {line-height: 1.5;}
  a { text-decoration:none; color: #386ee7; cursor: pointer; }
  table { border-collapse: collapse; }

  ${fontFaceStyles}
`;
const editorPasteConfig = {
    paste_remove_styles_if_webkit: false,
    paste_enable_default_filters: false,
    paste_data_images: true,
    paste_preprocess: (plugin, args) => { },
};
const tableConfig = {
    table_toolbar: 'tabledelete | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol',
};
const contextmenu = editor => {
    const res = editor.selection.getContent()
        ? 'cut copy paste pastetext lxcontextchangeimage | link linkchecker image imagetools spellchecker configurepermanentpen lximg | table | lxcontextOptimize'
        : 'paste pastetext | link linkchecker image imagetools spellchecker configurepermanentpen lximg | table';
    return res;
};
let lang = DEFAULT_LANG;
if (inWindow()) {
    lang = systemApi.getSystemLang() || DEFAULT_LANG;
}
const langMap = {
    en: '',
    zh: 'zh_CN',
    'zh-trad': 'zh_Trad',
};
const Arial = getIn18Text('SIYUANHEITI');
const fontFormats = `微软雅黑=Microsoft YaHei,微软雅黑;隶书=LiSu,隶书;幼圆=YouYuan,幼圆;Calibri=Calibri;${Arial}Arial Black=arial black,avant garde;Times New Roman=times new roman,times;Verdana=verdana,geneva;Lucida Grande=lucida grande;Menlo=menlo`;
const getFullpageBodyStyle = () => 'line-height: 1.5; font-size: 14px;font-family: Source Han Sans;';
export const editorConfig = Object.assign(Object.assign(Object.assign({}, editorPasteConfig), tableConfig), { content_style: tinyStyle, contextmenu,
    juice,
    handleCopyImg, placeholder: '', isEdm: process.env.BUILD_ISEDM, in_electron: inElectron, defaultStyle, min_height: 300, forced_root_block: 'div', font_size_legacy_values: '10px', fontsize_formats: '10px 11px 12px 13px 14px 16px 18px 20px 22px 24px 28px 32px 36px 48px', font_formats: fontFormats, toolbar_mode: 'sliding', valid_children: '+head[style],+body[style],+a[#text],+blockquote[style]', extended_valid_elements: 'svg,path,defs,linearGradient,stop,rect', statusbar: false, nonFormat: true, allow_html_in_named_anchor: true, fullpage_body_style: getFullpageBodyStyle, branding: false, elementpath: false, language: langMap[lang] || '', autoresize_bottom_margin: 0, indentation: '15px', menubar: false, content_security_policy: iframeCsp || undefined, nonbreaking_force_tab: true, custom_undo_redo_levels: 20, custom_colors: false, lineheight_formats: '1.0 1.5 1.75 2.0 3.0', table_sizing_mode: 'fixed', outTools: {
        debounce,
        throttle,
    }, plugins: [
        'advlist autolink lists link lximg image print preview autoresize fullpage media table paste code lxappendvar',
        'searchreplace visualblocks fullscreen nonbreaking lxgrammar lxsignature lxsalespitch lxaiwritemail lxinputdirection lximmutable lxsigbackspace',
        'lxuploadattachment lxmailformat lxcontact lxformatpainter wordcount lxemoji',
        'lxappendcommodity lxappendproduct lxsitelinkbtn lxcapturescreen lxsplitline lxbill lxappendlandingpage lxutils',
    ], immutable_selector: undefined, editable_signature_selector: '.mail-signature-ent' });
